/* eslint-disable no-shadow */
/*
 * App Actions
 *
 * Actions change things in your application
 * Since this boilerplate uses a uni-directional data flow, specifically redux,
 * we have these actions which are the only way your application interacts with
 * your application state. This guarantees that your state is up to date and nobody
 * messes it up weirdly somewhere.
 *
 * To add a new Action:
 * 1) Import your constant
 * 2) Add a function like this:
 *    export function yourAction(var) {
 *        return { type: YOUR_ACTION_CONSTANT, var: var }
 *    }
 */

import {
  GLOBAL_NOTIFY,
  GLOBAL_NOTIFY_ERROR,
  GLOBAL_NOTIFY_SUCCESS,
  LOGOUT,
  LOGOUT_ERROR,
  LOGOUT_SUCCESS,
  ENQUEUE_NOTIFICATION,
  REMOVE_NOTIFICATION,
  CLOSE_NOTIFICATION,
  GLOBAL_NOTIFY_INFO,
  CHANGE_ORDER_ROUTE,
  FETCH_ACCOUNT_STATUS,
  FETCH_ACCOUNT_STATUS_RETRY,
  FETCH_ACCOUNT_STATUS_SUCCESS,
  FETCH_ACCOUNT_STATUS_ERROR,
  USER_LEGAL_INFO_TERMS,
  // USER_LEGAL_INFO_COMPANY,
  // USER_LEGAL_INFO_LEGAL,
  POS_DETAILS,
  POS_DETAILS_SUCCESS,
  POS_DETAILS_ERROR,
  GLOBAL_ACCOUNT_STATUS,
  GLOBAL_ACCOUNT_STATUS_SUCCESS,
  GLOBAL_ACCOUNT_STATUS_ERROR,
  GLOBAL_MENU_OPEN,
  GLOBAL_MENU_CLOSE,
  SET_LOGGED_IN,
  SET_BACKDROP_OPENED,
} from './constants';

export function userLegalInfoTerms(option) {
  return {
    type: USER_LEGAL_INFO_TERMS,
    option,
  };
}

export function changeOrderRoute(route) {
  return {
    type: CHANGE_ORDER_ROUTE,
    route,
  };
}

export function logout() {
  return {
    type: LOGOUT,
  };
}

export function logoutSuccess() {
  return {
    type: LOGOUT_SUCCESS,
  };
}

export function logoutError() {
  return {
    type: LOGOUT_ERROR,
  };
}

export function setLoggedIn(value) {
  return {
    type: SET_LOGGED_IN,
    value,
  };
}

export function setBackdropOpened(value) {
  return {
    type: SET_BACKDROP_OPENED,
    value,
  };
}

export function notify(data) {
  return {
    type: GLOBAL_NOTIFY,
    ...data,
    variant: 'default',
  };
}

export function notifyInfo(data) {
  return {
    type: GLOBAL_NOTIFY_INFO,
    ...data,
    variant: 'default',
  };
}

export function notifyError(data) {
  return {
    type: GLOBAL_NOTIFY_ERROR,
    ...data,
    variant: 'error',
  };
}

export function notifySuccess(data) {
  return {
    type: GLOBAL_NOTIFY_SUCCESS,
    ...data,
    variant: 'success',
  };
}

export const enqueueNotification = (notification) => {
  const key = notification.options && notification.options.key;

  return {
    type: ENQUEUE_NOTIFICATION,
    notification: {
      ...notification,
      key: key || new Date().getTime() + Math.random(),
    },
  };
};

export const closeNotification = (key) => ({
  type: CLOSE_NOTIFICATION,
  dismissAll: !key, // dismiss all if no key has been defined
  key,
});

export const removeNotification = (key) => ({
  type: REMOVE_NOTIFICATION,
  key,
});

export function fetchAccountStatus() {
  return {
    type: FETCH_ACCOUNT_STATUS,
  };
}

export function fetchAccountStatusRetry() {
  return {
    type: FETCH_ACCOUNT_STATUS_RETRY,
  };
}

export function fetchAccountStatusSuccess(data) {
  return {
    type: FETCH_ACCOUNT_STATUS_SUCCESS,
    data,
  };
}

export function fetchAccountStatusError() {
  return {
    type: FETCH_ACCOUNT_STATUS_ERROR,
  };
}

export function getPosDetails(posType, id) {
  return {
    type: POS_DETAILS,
    posType,
    id,
  };
}

export function getPosDetailsSuccess(pos) {
  return {
    type: POS_DETAILS_SUCCESS,
    pos,
  };
}

export function getPosDetailsError() {
  return {
    type: POS_DETAILS_ERROR,
  };
}

export function getAccountStatus() {
  return {
    type: GLOBAL_ACCOUNT_STATUS,
  };
}

export function getAccountStatusSuccess() {
  return {
    type: GLOBAL_ACCOUNT_STATUS_SUCCESS,
  };
}

export function getAccountStatusError() {
  return {
    type: GLOBAL_ACCOUNT_STATUS_ERROR,
  };
}

export function globalMenuOpen() {
  return {
    type: GLOBAL_MENU_OPEN,
  };
}

export function globalMenuClose() {
  return {
    type: GLOBAL_MENU_CLOSE,
  };
}
